import { icons } from '@icons/icons.js';

/** Virtual category: rated products sorted by average score (not stored on products). */
export const POPULAR_CATEGORY_ID = 'popular';

export const Categories = [

    { id: POPULAR_CATEGORY_ID, label: 'Popular', icon: icons.popular },

    { id: 'cat-frozen-001', label: 'Helados y Copas', icon: icons.CopaHelado },

    { id: 'cat-desserts-001', label: 'Tortas y Postres', icon: icons.pastel },

    { id: 'cat-waffles-001', label: 'Waffles', icon: icons.waffle },

    { id: 'cat-crepes-001', label: 'Crepas Dulces', icon: icons.crepaDulce },

    { id: 'cat-ermita-products-001', label: 'Especialidades de La Ermita', icon: icons.especialidadesErmita },

    { id: 'cat-slushies-001', label: 'Bebidas Frías', icon: icons.bebidasFrias },

    { id: 'cat-milkshakes-001', label: 'Batidos y Malteadas', icon: icons.malteada },

    { id: 'cat-liqueurs-001', label: 'Bebidas con Alcohol', icon: icons.bebidasConAlcohol },

    { id: 'cat-hot-drinks-001', label: 'Cafetería', icon: icons.bebidasCalientes },

    { id: 'cat-savory-001', label: 'Delicias Saladas', icon: icons.deliciasDeSal },
];